import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-preview-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './preview-table.component.html',
  styleUrls: ['./preview-table.component.scss']
})
export class PreviewTableComponent {
  @Input() cols: string[] = [];
  @Input() rows: any[][] = [];
  @Input() maxRows: number = 5;

  get previewRows(): any[][] {
    return this.rows.slice(0, this.maxRows);
  }

  cellValue(row: any[], colIndex: number): string {
    const v = row[colIndex];
    return v !== undefined && v !== null ? String(v) : '';
  }
}
